import LazyLoad from 'react-lazyload';
import { images } from '../../../Constants/ImageUrls';
import { HappinessImage } from './styled';

export default function HappinessPattern(props) {
  const { showOnMobile } = props;
  return (
    <LazyLoad height={22} once offset={100}>
      <HappinessImage
        showOnMobile={showOnMobile}
        src={images.happinesspatternsingle}
        // srcSet={`${getMobileImage()}?tr=w-720,q-80 2w, ${getDesktopImage()}?tr=w-1900,q-80 1400w`}
        // sizes="(max-width: 720px) 2px,1400px"
        alt="happiness_pattern"
        width="328"
        height="21"
      />
    </LazyLoad>
  );
}
